import React, { useState } from 'react'
import { Label } from '../../atoms/texts/label';
export default function PrintWarningMessage({ warning, className, dismissible }) {
    const [visible, setVisible] = useState(true);

    if (visible) {

        return (
            <div className={`flex flex-col p-secondDegree border border-warning rounded-sm bg-warning20 ${className}`}>

                <Label message={warning}>{warning}</Label>                
                {dismissible && <Button style="ghost" sizePadding="medium" showLeftIcon leftIcon={<CloseRoundedIcon />} showText={false} onClick={() => setVisible(false)} className="text-error rounded-sm"></Button>}

            </div>
        );
    } else {
        return <></>
    }
}
